import React from 'react';
import { DataPoint, FroudVsRejection } from '../../../../dto/Interfaces/FrontendAnalytics/IFrontendAnalytics';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine, Label } from 'recharts';
import CustomTooltip from './CustomTooltip';
import { useTheme } from '@mui/material';
import { returnThemeSpacingAsNumber } from '../../../../utils/functions';

export interface FraudDetectionVsApprovalReductionChartProps {
  type: 'fraudDetectionVsApprovalReductionChart';
  data: DataPoint[];
  fvsr: FroudVsRejection[];
}

const FraudDetectionVsApprovalReductionChart: React.FC<FraudDetectionVsApprovalReductionChartProps> = ({ data, fvsr }) => {
  const theme = useTheme();
  const midIndex = fvsr.findIndex((element) => element.s === 450);
  const midValue = fvsr.find((element) => element.s === 450)?.fdr;

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={300}
        height={300}
        data={data}
        margin={{
          top: returnThemeSpacingAsNumber(theme.spacing(1.25)),
          right: returnThemeSpacingAsNumber(theme.spacing(3.75)),
          left: returnThemeSpacingAsNumber(theme.spacing(2.5)),
          bottom: returnThemeSpacingAsNumber(theme.spacing(2.5)),
        }}
      >
        <CartesianGrid strokeDasharray="1 1" />
        <Tooltip content={<CustomTooltip fvsr={fvsr} />} />
        <Line type="monotone" dataKey="y" stroke={theme.palette.primary.main} dot={false} strokeWidth={3} />
        <XAxis dataKey="x" tickFormatter={() => ''}>
          <Label
            value="Fraud detection rate"
            offset={-5}
            position="insideBottom"
            style={{ textAnchor: 'middle', marginBottom: theme.spacing(2), height: 50 }}
          />
        </XAxis>
        <YAxis>
          <Label value="Approval reduction rate" angle={-90} offset={10} position="insideLeft" style={{ textAnchor: 'middle' }} />
        </YAxis>
        <ReferenceLine x={fvsr.length > 20 ? (midIndex !== -1 ? midIndex : 11) : midValue} stroke="red" strokeWidth={1} strokeDasharray="3 3" />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default FraudDetectionVsApprovalReductionChart;
